<div *ngIf="data.mode==='success'">
  <div class="popup-alert">
    <span class="sa-icon sa-success animate">
      <span class="sa-line sa-tip animateSuccessTip"></span>
      <span class="sa-line sa-long animateSuccessLong"></span>
      <span class="sa-placeholder"></span>
      <div class="sa-fix"></div>
    </span>
  </div>
  <div class="text-center mb-5 text-uppercase">
    <h3>{{data.mainMessage}}</h3>
  </div>
  <div class="popup-alert-well p-20">
    <p *ngIf="!hasInnerHTML"> <b> {{data.title}}</b> {{data.body}}</p>
    <div *ngIf="hasInnerHTML"> <b> {{data.title}} </b> <div [innerHTML]="data.body"></div> </div>
  </div>
</div>
<div *ngIf="data.mode==='fail'">
  <div class="popup-alert">
    <span class="sa-icon sa-error animateErrorIcon">
      <span class="sa-x-mark animateXMark">
          <span class="sa-line sa-left"></span>
          <span class="sa-line sa-right"></span>
      </span>
    </span>
  </div>
  <div class="text-center mb-5 text-uppercase">
    <h3>{{data.mainMessage}}</h3>
  </div>
  <div class="popup-alert-well p-20">
    <p *ngIf="!hasInnerHTML"> <b> {{data.title}}</b> {{data.body}}</p>
    <div *ngIf="hasInnerHTML"> <b> {{data.title}} </b> <div [innerHTML]="data.body"></div> </div>
  </div>
</div>
<div *ngIf="data.mode==='refresh'">
  <div class="popup-alert">
    <span class="sa-icon sa-refresh animate">
      <span class="sa-line sa-tip animateSuccessTip"></span>
      <span class="sa-line sa-long animateSuccessLong"></span>
      <span class="sa-placeholder"></span>
      <div class="sa-fix"></div>
    </span>
  </div>
  <div class="text-center mb-5 text-uppercase">
    <h3>{{data.mainMessage}}</h3>
  </div>
  <div class="popup-alert-well p-20">
    <p *ngIf="!hasInnerHTML"> <b> {{data.title}}</b> {{data.body}}</p>
    <div *ngIf="hasInnerHTML"> <b> {{data.title}} </b> <div [innerHTML]="data.body"></div> </div>
  </div>
</div>